<span
  class="icc-radio-wrapper"
  >
  <span class="icc-radio-container">
    <span class="icc-radio-frame">

        <input
          type="radio"
          [checked]="checked"
          [attr.required]="required ? true : null"
          [attr.disabled]="disabled ? true : null"
          [attr.name]="name ? name : null"
          [attr.id]="id ? id + '-input' : null"
          [attr.value]="value"
          (change)="_onInputChange($event)"
          (click)="_onInputClick($event)"
          #input
        />

        <span class="icc-radio-background">
          <icc-icon class="icc-radio-background-checked" name="radio_button_checked"  ></icc-icon>
          <icc-icon class="icc-radio-background-unchecked" name="radio_button_unchecked" ></icc-icon>
        </span>

    </span>
    <label [attr.for]="id ? id + '-input' : null">
      <ng-content></ng-content>
    </label>
  </span>
</span>

